export const RUNNING_BORDER_ID = 3;
export const CROSS_COUNTRY_SKIING_ID = 5;
export const SWIMMING_BORDER_ID = 52;
export const CYCLING_BORDER_MOUNTAINBIKE_ID = 56;
export const CYCLING_BORDER_ROAD_ID = 26;
